import React from "react";
import { Box } from "@mui/material";
import Menu from "../components/Menu";

const LayoutDashboard = ({ children }) => {
  return (
    <Box sx={{ display:"flex", minHeight:"100vh" }}>

      <Menu />

      <Box
component="main"
sx={{
  flexGrow: 1,
  mt: { xs: "64px", md: 0 },
  px: { xs: 1.5, sm: 2.5, md: 3 },
  py: { xs: 2, md: 3 },
  width: "100%",
  minWidth: 0,
  overflowX: "hidden",
  background: "#f7faff"
}}
>
        {children}
      </Box>

    </Box>
  );
};

export default LayoutDashboard;